import { supabase } from '@/core/database/supabase';
import { AIPersona, AIPersonaPayload } from '../types/persona.type';

export const personasService = {
  async getPersonas(companyId: string): Promise<AIPersona[]> {
    const { data, error } = await supabase
      .from('ai_personas')
      .select('*')
      .eq('company_id', companyId)
      .order('code', { ascending: true });

    if (error) throw error;
    return data || [];
  },

  async createPersona(companyId: string, payload: AIPersonaPayload): Promise<AIPersona> {
    const { data, error } = await supabase
      .from('ai_personas')
      .insert([{ ...payload, company_id: companyId }])
      .select()
      .single();

    if (error) throw error;
    return data;
  },

  async updatePersona(id: string, payload: Partial<AIPersonaPayload>): Promise<AIPersona> {
    const { data, error } = await supabase
      .from('ai_personas')
      .update({ ...payload, updated_at: new Date().toISOString() })
      .eq('id', id)
      .select()
      .single();

    if (error) throw error;
    return data;
  },

  async deletePersona(id: string): Promise<void> {
    const { error } = await supabase
      .from('ai_personas')
      .delete()
      .eq('id', id);

    if (error) throw error;
  },
  
  async toggleStatus(id: string, currentStatus: boolean): Promise<AIPersona> {
    const { data, error } = await supabase
      .from('ai_personas')
      .update({ is_active: !currentStatus })
      .eq('id', id)
      .select()
      .single();
      
    if (error) throw error;
    return data;
  },

  async seedDefaultPersonas(companyId: string): Promise<AIPersona[]> {
    const { DEFAULT_AGENT_PERSONAS } = await import('@/core/ai/ai.service');
    
    // Xóa toàn bộ dữ liệu cũ để tránh trùng lặp khi cập nhật
    await supabase.from('ai_personas').delete().eq('company_id', companyId);

    const payloads = Object.values(DEFAULT_AGENT_PERSONAS).map(p => ({
      company_id: companyId,
      code: p.id.toUpperCase(),
      name: p.name,
      icon: (p as any).icon || 'ri-robot-line',
      instruction: p.instruction,
      is_active: true
    }));

    const { data, error } = await supabase
      .from('ai_personas')
      .insert(payloads)
      .select();

    if (error) throw error;
    return data || [];
  }
};
// Trigger Vite HMR
